<template>
    <div>
        <div class="panel">
            <van-row>
                <div class="top">
                    <div class="logo"><img src="../../assets/mtsj-logo.png" /></div>
                    <div class="title">梅唐四季自产</div>
                    <div class="status">
                        <van-tag v-if="p_action==1" plain type="danger">{{p_order.order_status_name}}</van-tag>
                        <van-tag v-if="p_action==2" plain type="danger">{{p_order.commission_status_name}}</van-tag>
                    </div>
                </div>
            </van-row>
            <div v-for="(item,index) in p_order.details" :key="index">
                <van-row>
                    <van-col span="6">
                        <div class="item-img"><img :src="item.thumb" /></div>
                    </van-col>
                    <van-col span="14">
                        <div class="center">
                            <div class="text">{{item.product_name}}</div>
                            <div class="bottom-panel">
                                <div class="price">
                                    <span>金额</span>
                                    <span class="price-code">￥</span>
                                    <span>{{item.money}}</span>
                                </div>
                                <div v-if="p_action==2" class="commission">
                                    <span>佣金</span>
                                    <span class="price-code">￥</span>
                                    <span>{{item.commission}}</span>
                                </div>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="4">
                        <div class="right">
                            <div class="price">￥{{item.price}}</div>
                            <div class="qty">x{{item.order_qty}}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="sum-row" v-if="p_action==1">
                <span class="total-label">总价</span>
                <span class="total-code">￥</span>
                <span class="total-val">{{sum_detail_money}}</span>
                <span class="real-label">实付款</span>
                <span class="real-code">￥</span>
                <span class="real-val">{{p_order.real_pay_money}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrderItem",
        props:{
            p_order:{
                type:Object,
                default:null,
                required:true,
            },
            p_action:{
                type:String,
                default:'1',    //1梅唐四季，2耘径联盟
                required:true,
            }
        },
        data(){
            return{
                moment:this.$moment,
            }
        },
        computed:{
            sum_detail_money(){
                let sum=0;
                for(let i=0;i<this.p_order.details.length;i++){
                    sum+=parseFloat(this.p_order.details[i].money);
                }
                return sum;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .panel{
        background-color: #FFFFFF;
        margin: 14px;
        border-radius: 10px;
        .top{
            text-align: left;
            padding: 4px;
            .logo{
                display: inline-block;
                line-height: 30px;
                img{
                    vertical-align: middle;
                    width: 20px;
                    height: 20px;
                }
            }
            .title{
                display: inline-block;
                font-size: 12px;
                color: #666666;
                font-weight: bold;
                padding-left: 5px;
            }
            .status{
                display: inline-block;
                float: right;
                padding: 4px;
            }
        }
        .item-img{
            font-size:0;
            padding: 0 0 4px 4px;
            img {
                width: 90px;
                height: 90px;
            }
        }
        .center{
            text-align: left;
            padding-left: 14px;
            position: relative;
            min-height: 95px;
            .text{
                font-size: 14px;
                color: #333333;
            }
            .order-time{
                color: #999999;
                padding-top: 4px;
                .label{
                    font-size: 12px;
                }
                .val{
                    font-size: 10px;
                }
            }
            .bottom-panel{
                position: absolute;
                bottom: 6px;
                width: 80%;
                .price{
                    display: inline-block;
                    font-size: 12px;
                    float: left;
                    color: #666666;
                    .price-code{
                        font-size: 10px;
                        color: #999999;
                    }
                }
                .commission{
                    display: inline-block;
                    float: right;
                    font-size: 12px;
                    font-weight: bold;
                    color: #E34928;
                    .price-code{
                        font-size: 10px;
                        color: #E87748;
                    }
                }
            }

        }
        .right{
            text-align: right;
            padding: 4px 4px 0 0;
            .price{
                font-size: 14px;
                color: #666666;
            }
            .qty{
                font-size: 10px;
                color: #666666;
            }
        }

        .sum-row{
            text-align: right;
            padding-right: 4px;
            .total-label{
                font-size: 12px;
                color: #999999;
            }
            .total-code{
                font-size: 10px;
                color: #999999;
            }
            .total-val{
                font-size: 14px;
                color: #999999;
            }
            .real-label{
                padding-left: 6px;
                font-size: 12px;
                font-weight: bold;
                color: #666666;
            }
            .real-code{
                font-size: 10px;
                color: #666666;
            }
            .real-val{
                font-size: 14px;
                font-weight: bold;
                color: #666666;
            }
        }
    }



</style>
